

// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// import {
//   Edit3,
//   Check,
//   X,
//   Filter,
//   ChevronLeft,
//   ChevronRight,
//   LogOut,
//   ChevronDown
// } from 'lucide-react';

// const AccountDashboard = () => {
//   const navigate = useNavigate();

//   // =========================================
//   // API URL
//   // =========================================
//   const API_URL = "https://backend.reportingbot.in/api";
//   // const API_URL = "http://localhost:8000/api";

//   // =========================================
//   // DATA STATES
//   // =========================================
//   const [data, setData] = useState([]);

//   // FILTER OPTIONS
//   const [institutions, setInstitutions] = useState([]);
//   const [modalities, setModalities] = useState([]);
//   const [doctors, setDoctors] = useState([]);

//   // TOTALS
//   const [totalRevenue, setTotalRevenue] = useState(0);
//   const [totalDoctorRevenue, setTotalDoctorRevenue] = useState(0);

//   // UI STATES
//   const [editId, setEditId] = useState(null);
//   const [showFilters, setShowFilters] = useState(false);

//   const [tempRates, setTempRates] = useState({
//     rate: 0,
//     doctor_rate: 0
//   });

//   // FILTER STATES
//   const [filters, setFilters] = useState({
//     patient_name: '',
//     patient_id: '',
//     institution_name: [], 
//     modality: '',
//     reported_by: [],      
//     status: '',
//     start_date: '',
//     end_date: ''
//   });

//   // PAGINATION
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalCount, setTotalCount] = useState(0);
//   const itemsPerPage = 50;

//   // =========================================
//   // FETCH DATA FROM API
//   // =========================================
//   useEffect(() => {
//     fetchTransactions();
//   }, [currentPage, filters]);

//   const fetchTransactions = async () => {
//     try {
//       const queryParams = new URLSearchParams({
//         page: currentPage,
//         limit: itemsPerPage,

//         patient_name: filters.patient_name,
//         patient_id: filters.patient_id,
//         modality: filters.modality,
//         status: filters.status,
//         start_date: filters.start_date,
//         end_date: filters.end_date,

//         institution_name: filters.institution_name?.length ? filters.institution_name.join(',') : '',
//         reported_by: filters.reported_by?.length ? filters.reported_by.join(',') : ''
//       });

//       const response = await axios.get(`${API_URL}/transactions/?${queryParams}`);

//       setData(response.data.results);
//       setTotalCount(response.data.count);
//       setTotalRevenue(response.data.total_revenue);
//       setTotalDoctorRevenue(response.data.total_doctor_revenue);
//       setInstitutions(response.data.filters.institutions);
//       setModalities(response.data.filters.modalities);
//       setDoctors(response.data.filters.doctors);

//     } catch (error) {
//       console.log("Fetch Error:", error);
//     }
//   };

//   // =========================================
//   // UPDATE RATE API
//   // =========================================
//   const saveRates = async (id) => {
//     try {
//       const response = await axios.put(
//         `${API_URL}/transactions/update/${id}/`,
//         {
//           rate: tempRates.rate,
//           doctor_rate: tempRates.doctor_rate
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       setData(
//         data.map(item =>
//           item.id === id
//             ? {
//                 ...item,
//                 rate: response.data.rate,
//                 doctor_rate: response.data.doctor_rate,
//                 previous_rate: response.data.previous_rate,
//                 previous_doctor_rate: response.data.previous_doctor_rate,
//                 status: response.data.status
//               }
//             : item
//         )
//       );
//       setEditId(null);
//     } catch (error) {
//       console.log("Update Error:", error);
//     }
//   };

//   const handleFilterChange = (e) => {
//     setCurrentPage(1);
//     setFilters({
//       ...filters,
//       [e.target.name]: e.target.value
//     });
//   };

//   const clearFilters = () => {
//     setFilters({
//       patient_name: '',
//       patient_id: '',
//       institution_name: [],
//       modality: '',
//       reported_by: [],
//       status: '',
//       start_date: '',
//       end_date: ''
//     });
//   };

//   const totalPages = Math.ceil(totalCount / itemsPerPage) || 1;

//   return (
//     <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-900">
      
//       {/* ========================================= */}
//       {/* TOP SECTION (Scrolls away normally)     */}
//       {/* ========================================= */}
//       <div className="px-4 lg:px-8 pt-4 lg:pt-8 pb-2">
//         {/* HEADER */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
//           <div>
//             <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight italic">
//               U4RAD Dashboard
//             </h1>
//             <p className="text-sm text-slate-500">
//               Reporting Accounts & Financial Logs
//             </p>
//           </div>
//           <button
//             onClick={() => navigate('/logout')}
//             className="flex items-center gap-2 bg-red-50 text-red-600 border border-red-200 px-4 py-2 rounded-lg hover:bg-red-100 hover:border-red-300 transition-colors font-semibold shadow-sm"
//           >
//             <LogOut size={16} />
//             Logout
//           </button>
//         </div>

//         {/* REVENUE CARDS */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-2">
//           <div className="bg-red-600 text-white px-4 py-3 rounded-lg shadow-sm">
//             <p className="text-[11px] uppercase tracking-wide">
//               Total Client Revenue
//             </p>
//             <h2 className="text-xl font-bold">
//               ₹{totalRevenue}
//             </h2>
//           </div>
//           <div className="bg-blue-600 text-white px-4 py-3 rounded-lg shadow-sm">
//             <p className="text-[11px] uppercase tracking-wide">
//               Total Doctor Payment
//             </p>
//             <h2 className="text-xl font-bold">
//               ₹{totalDoctorRevenue}
//             </h2>
//           </div>
//         </div>
//       </div>

//       {/* ========================================= */}
//       {/* STICKY INTERACTIVE SECTION                */}
//       {/* Locks to the top when scrolled            */}
//       {/* ========================================= */}
//       <div className="sticky top-0 h-[100dvh] flex flex-col px-4 lg:px-8 pt-4 pb-4 lg:pb-8 z-30 pointer-events-none">
        
//         {/* Re-enable pointer events for the interactive content */}
//         <div className="pointer-events-auto h-full flex flex-col min-h-0">
          
//           {/* FILTER PANEL */}
//           <div className="flex-shrink-0 bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
//             <div className="flex flex-col lg:flex-row gap-4 lg:items-end justify-between">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1">
//                 <FilterInput
//                   label="Search Name"
//                   name="patient_name"
//                   value={filters.patient_name}
//                   onChange={handleFilterChange}
//                   placeholder="Search patient name..."
//                 />
//                 <FilterInput
//                   label="Search ID"
//                   name="patient_id"
//                   value={filters.patient_id}
//                   onChange={handleFilterChange}
//                   placeholder="Search patient ID..."
//                 />
//               </div>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => setShowFilters(!showFilters)}
//                   className="flex items-center gap-2 bg-slate-800 text-white px-5 py-2.5 rounded-lg hover:bg-slate-700 transition"
//                 >
//                   <Filter size={16} />
//                   Filters
//                 </button>
//                 <button
//                   onClick={clearFilters}
//                   className="border border-red-300 text-red-600 px-5 py-2.5 rounded-lg hover:bg-red-50 transition"
//                 >
//                   Clear All
//                 </button>
//               </div>
//             </div>

//             {/* EXPANDABLE FILTERS */}
//             {showFilters && (
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6 items-start">
//                 <MultiFilterSelect
//                   label="Institution"
//                   name="institution_name"
//                   value={filters.institution_name}
//                   options={institutions}
//                   onChange={handleFilterChange}
//                 />
//                 <FilterSelect
//                   label="Modality"
//                   name="modality"
//                   value={filters.modality}
//                   options={modalities}
//                   onChange={handleFilterChange}
//                 />
//                 <FilterSelect
//                   label="Status"
//                   name="status"
//                   value={filters.status}
//                   options={["PENDING", "SUCCESS", "FAILED"]}
//                   onChange={handleFilterChange}
//                 />
//                 <MultiFilterSelect
//                   label="Reported By"
//                   name="reported_by"
//                   value={filters.reported_by}
//                   options={doctors}
//                   onChange={handleFilterChange}
//                 />
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] uppercase font-bold text-slate-400">
//                     Start Date
//                   </label>
//                   <input
//                     type="date"
//                     name="start_date"
//                     value={filters.start_date}
//                     onChange={handleFilterChange}
//                     className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
//                   />
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] uppercase font-bold text-slate-400">
//                     End Date
//                   </label>
//                   <input
//                     type="date"
//                     name="end_date"
//                     value={filters.end_date}
//                     onChange={handleFilterChange}
//                     className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
//                   />
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* TABLE CONTAINER */}
//           <div className="flex-1 bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col min-h-0 relative">
//             <div className="flex-1 overflow-auto">
//               <table className="w-full border-collapse text-left text-sm relative">
//                 <thead className="sticky top-0 z-20 bg-slate-800 shadow-sm">
//                   <tr className="text-slate-200 text-[11px] uppercase tracking-wider font-semibold">
//                     <th className="px-4 py-4">#</th>
//                     <th className="px-4 py-4">Patient Name</th>
//                     <th className="px-4 py-4">Patient ID</th>
//                     <th className="px-4 py-4">Institution</th>
//                     <th className="px-4 py-4">Study Description</th>
//                     <th className="px-4 py-4 text-center">Views</th>
//                     <th className="px-4 py-4">Modality</th>
//                     <th className="px-4 py-4">Rate (₹)</th>
//                     <th className="px-4 py-4">Doctor Rate (₹)</th>
//                     <th className="px-4 py-4">Status</th>
//                     <th className="px-4 py-4">Date</th>
//                     <th className="px-4 py-4">Time</th>
//                     <th className="px-4 py-4">Reported By</th>
//                     <th className="px-4 py-4 text-right">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-slate-100">
//                   {data.length > 0 ? (
//                     data.map((row, index) => (
//                       <tr key={row.id} className="hover:bg-blue-50/40 transition-colors">
//                         <td className="px-4 py-4 text-slate-400 font-medium">
//                           {(currentPage - 1) * itemsPerPage + index + 1}
//                           {(row.previous_rate > 0 || row.previous_doctor_rate > 0) && (
//                             <span 
//                               className="text-red-500 font-bold ml-0.5 text-lg" 
//                               title={`Previous Rate: ₹${row.previous_rate} | Previous Dr Rate: ₹${row.previous_doctor_rate}`}
//                             >
//                               *
//                             </span>
//                           )}
//                         </td>
//                         <td className="px-4 py-4 font-semibold text-blue-600">
//                           {row.patient_name}
//                         </td>
//                         <td className="px-4 py-4 text-slate-500">
//                           {row.patient_id}
//                         </td>
//                         <td className="px-4 py-4 italic">
//                           {row.institution_name}
//                         </td>
//                         <td className="px-4 py-4">
//                           {row.study_description}
//                         </td>
//                         <td className="px-4 py-4 text-center">
//                           {row.no_of_views}
//                         </td>
//                         <td className="px-4 py-4">
//                           {row.modality}
//                         </td>
//                         <td className="px-4 py-4">
//                           {editId === row.id ? (
//                             <input
//                               type="number"
//                               className="w-20 border rounded p-1"
//                               value={tempRates.rate}
//                               onChange={(e) => setTempRates({ ...tempRates, rate: e.target.value })}
//                             />
//                           ) : (
//                             <span>₹{row.rate}</span>
//                           )}
//                         </td>
//                         <td className="px-4 py-4">
//                           {editId === row.id ? (
//                             <input
//                               type="number"
//                               className="w-20 border rounded p-1"
//                               value={tempRates.doctor_rate}
//                               onChange={(e) => setTempRates({ ...tempRates, doctor_rate: e.target.value })}
//                             />
//                           ) : (
//                             <span>₹{row.doctor_rate}</span>
//                           )}
//                         </td>
//                         <td className="px-4 py-4">
//                           <span className={`px-2 py-1 rounded text-xs font-bold ${
//                             row.status === "SUCCESS" ? "bg-green-100 text-green-700" :
//                             row.status === "FAILED" ? "bg-red-100 text-red-700" :
//                             "bg-yellow-100 text-yellow-700"
//                           }`}>
//                             {row.status}
//                           </span>
//                         </td>
//                         <td className="px-4 py-4">{row.report_date}</td>
//                         <td className="px-4 py-4">{row.report_time}</td>
//                         <td className="px-4 py-4">{row.reported_by}</td>
//                         <td className="px-4 py-4 text-right">
//                           {editId === row.id ? (
//                             <div className="flex justify-end gap-2">
//                               <button onClick={() => saveRates(row.id)} className="bg-green-500 text-white p-1.5 rounded">
//                                 <Check size={14} />
//                               </button>
//                               <button onClick={() => setEditId(null)} className="bg-gray-400 text-white p-1.5 rounded">
//                                 <X size={14} />
//                               </button>
//                             </div>
//                           ) : (
//                             <button
//                               onClick={() => {
//                                 setEditId(row.id);
//                                 setTempRates({ rate: row.rate, doctor_rate: row.doctor_rate });
//                               }}
//                               className="text-blue-600"
//                             >
//                               <Edit3 size={16} />
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="14" className="py-20 text-center text-slate-500">No entries found.</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Container */}
//             <div className="p-4 border-t flex justify-between items-center bg-white flex-shrink-0 rounded-b-xl z-20">
//               <span className="text-sm">Page {currentPage} of {totalPages}</span>
//               <div className="flex gap-2">
//                 <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)} className="p-2 border rounded">
//                   <ChevronLeft size={18} />
//                 </button>
//                 <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)} className="p-2 border rounded">
//                   <ChevronRight size={18} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // =========================================
// // FILTER INPUT COMPONENTS (Unchanged)
// // =========================================
// const FilterInput = ({ label, name, value, onChange, placeholder }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[10px] uppercase font-bold text-slate-400">
//       {label}
//     </label>
//     <input
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
//     />
//   </div>
// );

// const FilterSelect = ({ label, name, value, options, onChange }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[10px] uppercase font-bold text-slate-400">
//       {label}
//     </label>
//     <select
//       name={name}
//       value={value}
//       onChange={onChange}
//       className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
//     >
//       <option value="">All</option>
//       {options.map((opt, index) => (
//         <option key={index} value={opt}>{opt}</option>
//       ))}
//     </select>
//   </div>
// );

// const MultiFilterSelect = ({ label, name, value = [], options, onChange }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleCheckboxChange = (opt) => {
//     let newValue = [...value];
//     if (newValue.includes(opt)) {
//       newValue = newValue.filter(item => item !== opt);
//     } else {
//       newValue.push(opt);
//     }
//     onChange({ target: { name, value: newValue } });
//   };

//   const clearSelection = () => {
//     onChange({ target: { name, value: [] } });
//   };

//   let displayText = "All";
//   if (value.length === 1) displayText = value[0];
//   else if (value.length > 1) displayText = `${value.length} Selected`;

//   return (
//     <div className="flex flex-col gap-1 relative" ref={dropdownRef}>
//       <label className="text-[10px] uppercase font-bold text-slate-400">
//         {label}
//       </label>
//       <div
//         onClick={() => setIsOpen(!isOpen)}
//         className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px] flex items-center justify-between cursor-pointer"
//       >
//         <span className="truncate text-slate-700">{displayText}</span>
//         <ChevronDown size={14} className="text-slate-400" />
//       </div>
//       {isOpen && (
//         <div className="absolute z-50 top-[60px] left-0 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//           <div 
//             className="px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer border-b border-slate-100 text-red-500 font-medium sticky top-0 bg-white"
//             onClick={clearSelection}
//           >
//             Clear Selection
//           </div>
//           {options.map((opt, index) => (
//             <label key={index} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={value.includes(opt)}
//                 onChange={() => handleCheckboxChange(opt)}
//                 className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//               />
//               <span className="truncate text-slate-700">{opt}</span>
//             </label>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AccountDashboard;              



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import {
  Edit3,
  Check,
  X,
  Filter,
  ChevronLeft,
  ChevronRight,
  LogOut,
  ChevronDown
} from 'lucide-react';

// ✅ ADDED: Helper function to get the current month's start and end dates
const getCurrentMonthDates = () => {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, '0');
  const lastDate = new Date(y, today.getMonth() + 1, 0).getDate();
  
  return {
    firstDay: `${y}-${m}-01`,
    lastDay: `${y}-${m}-${lastDate}`
  };
};

const AccountDashboard = () => {
  const navigate = useNavigate();

  // =========================================
  // API URL
  // =========================================
  const API_URL = "https://backend.reportingbot.in/api";
  // const API_URL = "http://localhost:8000/api";

  // =========================================
  // DATA STATES
  // =========================================
  const [data, setData] = useState([]);

  // FILTER OPTIONS
  const [institutions, setInstitutions] = useState([]);
  const [modalities, setModalities] = useState([]);
  const [doctors, setDoctors] = useState([]);

  // TOTALS
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalDoctorRevenue, setTotalDoctorRevenue] = useState(0);

  // UI STATES
  const [editId, setEditId] = useState(null);
  const [showFilters, setShowFilters] = useState(false);

  const [tempRates, setTempRates] = useState({
    rate: 0,
    doctor_rate: 0
  });

  // ✅ ADDED: Get the dates for the initial state
  const { firstDay, lastDay } = getCurrentMonthDates();

  // FILTER STATES
  const [filters, setFilters] = useState({
    patient_name: '',
    patient_id: '',
    institution_name: [], 
    modality: '',
    reported_by: [],      
    status: '',
    start_date: firstDay, // ✅ CHANGED: Set default to 1st day of month
    end_date: lastDay     // ✅ CHANGED: Set default to last day of month
  });

  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 50;

  // =========================================
  // FETCH DATA FROM API
  // =========================================
  useEffect(() => {
    fetchTransactions();
  }, [currentPage, filters]);

  const fetchTransactions = async () => {
    try {
      const queryParams = new URLSearchParams({
        page: currentPage,
        limit: itemsPerPage,

        patient_name: filters.patient_name,
        patient_id: filters.patient_id,
        modality: filters.modality,
        status: filters.status,
        start_date: filters.start_date,
        end_date: filters.end_date,

        // institution_name: filters.institution_name?.length ? filters.institution_name.join(',') : '',
        // reported_by: filters.reported_by?.length ? filters.reported_by.join(',') : '' 
        institution_name: filters.institution_name?.length ? filters.institution_name.join('|') : '',
        reported_by: filters.reported_by?.length ? filters.reported_by.join('|') : ''
});
      

      const response = await axios.get(`${API_URL}/transactions/?${queryParams}`);

      setData(response.data.results);
      setTotalCount(response.data.count);
      setTotalRevenue(response.data.total_revenue);
      setTotalDoctorRevenue(response.data.total_doctor_revenue);
      setInstitutions(response.data.filters.institutions);
      setModalities(response.data.filters.modalities);
      setDoctors(response.data.filters.doctors);

    } catch (error) {
      console.log("Fetch Error:", error);
    }
  };

  // =========================================
  // UPDATE RATE API
  // =========================================
  const saveRates = async (id) => {
    try {
      const response = await axios.put(
        `${API_URL}/transactions/update/${id}/`,
        {
          rate: tempRates.rate,
          doctor_rate: tempRates.doctor_rate
        },
        { headers: { "Content-Type": "application/json" } }
      );

      setData(
        data.map(item =>
          item.id === id
            ? {
                ...item,
                rate: response.data.rate,
                doctor_rate: response.data.doctor_rate,
                previous_rate: response.data.previous_rate,
                previous_doctor_rate: response.data.previous_doctor_rate,
                status: response.data.status
              }
            : item
        )
      );
      setEditId(null);
    } catch (error) {
      console.log("Update Error:", error);
    }
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const clearFilters = () => {
    setFilters({
      patient_name: '',
      patient_id: '',
      institution_name: [],
      modality: '',
      reported_by: [],
      status: '',
      start_date: firstDay, // ✅ CHANGED: Reset to 1st day of month
      end_date: lastDay     // ✅ CHANGED: Reset to last day of month
    });
  };

  // =========================================
  // GENERATE INVOICE
  // =========================================
  // const generateInvoice = () => {
  //   if (!filters.start_date || !filters.end_date) {
  //     alert("Please select both Start Date and End Date before generating the invoice.");
  //     return;
  //   }

  //   const params = new URLSearchParams({
  //     start_date: filters.start_date,
  //     end_date: filters.end_date,
  //     institution_name: filters.institution_name?.length
  //       ? filters.institution_name.join(',')
  //       : ''
  //   });

  //   window.open(`https://backend.reportingbot.in/api/invoice/?${params.toString()}`, "_blank");
  // };   

const generateInvoice = () => {
  if (!filters.start_date || !filters.end_date) {
    alert("Please select both Start Date and End Date before generating the invoice.");
    return;
  }

  const params = new URLSearchParams({
    start_date: filters.start_date,
    end_date: filters.end_date,
    institution_name: filters.institution_name?.length
      ? filters.institution_name.join('|')
      : ''
  });

  window.open(`https://backend.reportingbot.in/api/invoice/?${params.toString()}`, "_blank");
};
  const totalPages = Math.ceil(totalCount / itemsPerPage) || 1;

  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-900">
      
      {/* ========================================= */}
      {/* TOP SECTION (Scrolls away normally)     */}
      {/* ========================================= */}
      <div className="px-4 lg:px-8 pt-4 lg:pt-8 pb-2">
        {/* HEADER */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <div>
            <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight italic">
              U4RAD Dashboard
            </h1>
            <p className="text-sm text-slate-500">
              Reporting Accounts & Financial Logs
            </p>
          </div>
          <button
            onClick={() => navigate('/logout')}
            className="flex items-center gap-2 bg-red-50 text-red-600 border border-red-200 px-4 py-2 rounded-lg hover:bg-red-100 hover:border-red-300 transition-colors font-semibold shadow-sm"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>

        {/* REVENUE CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-2">
          <div className="bg-red-600 text-white px-4 py-3 rounded-lg shadow-sm">
            <p className="text-[11px] uppercase tracking-wide">
              Total Client Revenue
            </p>
            <h2 className="text-xl font-bold">
              ₹{totalRevenue}
            </h2>
          </div>
          <div className="bg-blue-600 text-white px-4 py-3 rounded-lg shadow-sm">
            <p className="text-[11px] uppercase tracking-wide">
              Total Doctor Payment
            </p>
            <h2 className="text-xl font-bold">
              ₹{totalDoctorRevenue}
            </h2>
          </div>
        </div>
      </div>

      {/* ========================================= */}
      {/* STICKY INTERACTIVE SECTION                */}
      {/* Locks to the top when scrolled            */}
      {/* ========================================= */}
      <div className="sticky top-0 h-[100dvh] flex flex-col px-4 lg:px-8 pt-4 pb-4 lg:pb-8 z-30 pointer-events-none">
        
        {/* Re-enable pointer events for the interactive content */}
        <div className="pointer-events-auto h-full flex flex-col min-h-0">
          
          {/* FILTER PANEL */}
          <div className="flex-shrink-0 bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
            <div className="flex flex-col lg:flex-row gap-4 lg:items-end justify-between">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1">
                <FilterInput
                  label="Search Name"
                  name="patient_name"
                  value={filters.patient_name}
                  onChange={handleFilterChange}
                  placeholder="Search patient name..."
                />
                <FilterInput
                  label="Search ID"
                  name="patient_id"
                  value={filters.patient_id}
                  onChange={handleFilterChange}
                  placeholder="Search patient ID..."
                />
              </div>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="flex items-center gap-2 bg-slate-800 text-white px-5 py-2.5 rounded-lg hover:bg-slate-700 transition"
                >
                  <Filter size={16} />
                  Filters
                </button>
                <button
                  onClick={clearFilters}
                  className="border border-red-300 text-red-600 px-5 py-2.5 rounded-lg hover:bg-red-50 transition"
                >
                  Clear All
                </button>
                <button
                  onClick={generateInvoice}
                  className="bg-emerald-600 text-white px-5 py-2.5 rounded-lg hover:bg-emerald-700 transition"
                >
                  Generate Invoice
                </button>
              </div>
            </div>

            {/* EXPANDABLE FILTERS */}
            {showFilters && (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6 items-start">
                <MultiFilterSelect
                  label="Institution"
                  name="institution_name"
                  value={filters.institution_name}
                  options={institutions}
                  onChange={handleFilterChange}
                />
                <FilterSelect
                  label="Modality"
                  name="modality"
                  value={filters.modality}
                  options={modalities}
                  onChange={handleFilterChange}
                />
                <FilterSelect
                  label="Status"
                  name="status"
                  value={filters.status}
                  options={["PENDING", "SUCCESS", "FAILED", "PARTIAL"]}
                  onChange={handleFilterChange}
                />
                <MultiFilterSelect
                  label="Reported By"
                  name="reported_by"
                  value={filters.reported_by}
                  options={doctors}
                  onChange={handleFilterChange}
                />
                <div className="flex flex-col gap-1">
                  <label className="text-[10px] uppercase font-bold text-slate-400">
                    Start Date
                  </label>
                  <input
                    type="date"
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleFilterChange}
                    className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-[10px] uppercase font-bold text-slate-400">
                    End Date
                  </label>
                  <input
                    type="date"
                    name="end_date"
                    value={filters.end_date}
                    onChange={handleFilterChange}
                    className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
                  />
                </div>
              </div>
            )}
          </div>

          {/* TABLE CONTAINER */}
          <div className="flex-1 bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col min-h-0 relative">
            <div className="flex-1 overflow-auto">
              <table className="w-full border-collapse text-left text-sm relative">
                <thead className="sticky top-0 z-20 bg-slate-800 shadow-sm">
                  <tr className="text-slate-200 text-[11px] uppercase tracking-wider font-semibold">
                    <th className="px-4 py-4">#</th>
                    <th className="px-4 py-4">Patient Name</th>
                    <th className="px-4 py-4">Patient ID</th>
                    <th className="px-4 py-4">Institution</th>
                    <th className="px-4 py-4">Study Description</th>
                    <th className="px-4 py-4 text-center">Views</th>
                    <th className="px-4 py-4">Modality</th>
                    <th className="px-4 py-4">Rate (₹)</th>
                    <th className="px-4 py-4">Doctor Rate (₹)</th>
                    <th className="px-4 py-4">Status</th>
                    <th className="px-4 py-4">Date</th>
                    <th className="px-4 py-4">Time</th>
                    <th className="px-4 py-4">Reported By</th>
                    <th className="px-4 py-4 text-right">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {data.length > 0 ? (
                    data.map((row, index) => (
                      <tr key={row.id} className="hover:bg-blue-50/40 transition-colors">
                        <td className="px-4 py-4 text-slate-400 font-medium">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                          {(row.previous_rate > 0 || row.previous_doctor_rate > 0) && (
                            <span 
                              className="text-red-500 font-bold ml-0.5 text-lg" 
                              title={`Previous Rate: ₹${row.previous_rate} | Previous Dr Rate: ₹${row.previous_doctor_rate}`}
                            >
                              *
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-4 font-semibold text-blue-600">
                          {row.patient_name}
                        </td>
                        <td className="px-4 py-4 text-slate-500">
                          {row.patient_id}
                        </td>
                        <td className="px-4 py-4 italic">
                          {row.institution_name}
                        </td>
                        <td className="px-4 py-4">
                          {row.study_description}
                        </td>
                        <td className="px-4 py-4 text-center">
                          {row.no_of_views}
                        </td>
                        <td className="px-4 py-4">
                          {row.modality}
                        </td>
                        <td className="px-4 py-4">
                          {editId === row.id ? (
                            <input
                              type="number"
                              className="w-20 border rounded p-1"
                              value={tempRates.rate}
                              onChange={(e) => setTempRates({ ...tempRates, rate: e.target.value })}
                            />
                          ) : (
                            <span>₹{row.rate}</span>
                          )}
                        </td>
                        <td className="px-4 py-4">
                          {editId === row.id ? (
                            <input
                              type="number"
                              className="w-20 border rounded p-1"
                              value={tempRates.doctor_rate}
                              onChange={(e) => setTempRates({ ...tempRates, doctor_rate: e.target.value })}
                            />
                          ) : (
                            <span>₹{row.doctor_rate}</span>
                          )}
                        </td>
                        <td className="px-4 py-4">
                          <span className={`px-2 py-1 rounded text-xs font-bold ${
                            row.status === "SUCCESS" ? "bg-green-100 text-green-700" :
                            row.status === "FAILED" ? "bg-red-100 text-red-700" :
                            row.status === "PARTIAL" ? "bg-orange-100 text-orange-700" :
                            "bg-yellow-100 text-yellow-700"
                          }`}>
                            {row.status}
                          </span>
                        </td>
                        <td className="px-4 py-4">{row.report_date}</td>
                        <td className="px-4 py-4">{row.report_time}</td>
                        <td className="px-4 py-4">{row.reported_by}</td>
                        <td className="px-4 py-4 text-right">
                          {editId === row.id ? (
                            <div className="flex justify-end gap-2">
                              <button onClick={() => saveRates(row.id)} className="bg-green-500 text-white p-1.5 rounded">
                                <Check size={14} />
                              </button>
                              <button onClick={() => setEditId(null)} className="bg-gray-400 text-white p-1.5 rounded">
                                <X size={14} />
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                setEditId(row.id);
                                setTempRates({ rate: row.rate, doctor_rate: row.doctor_rate });
                              }}
                              className="text-blue-600"
                            >
                              <Edit3 size={16} />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="14" className="py-20 text-center text-slate-500">No entries found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Container */}
            <div className="p-4 border-t flex justify-between items-center bg-white flex-shrink-0 rounded-b-xl z-20">
              <span className="text-sm">Page {currentPage} of {totalPages}</span>
              <div className="flex gap-2">
                <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)} className="p-2 border rounded">
                  <ChevronLeft size={18} />
                </button>
                <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)} className="p-2 border rounded">
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// =========================================
// FILTER INPUT COMPONENTS (Unchanged)
// =========================================
const FilterInput = ({ label, name, value, onChange, placeholder }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[10px] uppercase font-bold text-slate-400">
      {label}
    </label>
    <input
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
    />
  </div>
);

const FilterSelect = ({ label, name, value, options, onChange }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[10px] uppercase font-bold text-slate-400">
      {label}
    </label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px]"
    >
      <option value="">All</option>
      {options.map((opt, index) => (
        <option key={index} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

// const MultiFilterSelect = ({ label, name, value = [], options, onChange }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleCheckboxChange = (opt) => {
//     let newValue = [...value];
//     if (newValue.includes(opt)) {
//       newValue = newValue.filter(item => item !== opt);
//     } else {
//       newValue.push(opt);
//     }
//     onChange({ target: { name, value: newValue } });
//   };

//   const clearSelection = () => {
//     onChange({ target: { name, value: [] } });
//   };

//   let displayText = "All";
//   if (value.length === 1) displayText = value[0];
//   else if (value.length > 1) displayText = `${value.length} Selected`;

//   return (
//     <div className="flex flex-col gap-1 relative" ref={dropdownRef}>
//       <label className="text-[10px] uppercase font-bold text-slate-400">
//         {label}
//       </label>
//       <div
//         onClick={() => setIsOpen(!isOpen)}
//         className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px] flex items-center justify-between cursor-pointer"
//       >
//         <span className="truncate text-slate-700">{displayText}</span>
//         <ChevronDown size={14} className="text-slate-400" />
//       </div>
//       {isOpen && (
//         <div className="absolute z-50 top-[60px] left-0 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//           <div 
//             className="px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer border-b border-slate-100 text-red-500 font-medium sticky top-0 bg-white"
//             onClick={clearSelection}
//           >
//             Clear Selection
//           </div>
//           {options.map((opt, index) => (
//             <label key={index} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={value.includes(opt)}
//                 onChange={() => handleCheckboxChange(opt)}
//                 className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//               />
//               <span className="truncate text-slate-700">{opt}</span>
//             </label>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };


const MultiFilterSelect = ({ label, name, value = [], options, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // ✅ ADDED: State for search text
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCheckboxChange = (opt) => {
    let newValue = [...value];
    if (newValue.includes(opt)) {
      newValue = newValue.filter(item => item !== opt);
    } else {
      newValue.push(opt);
    }
    onChange({ target: { name, value: newValue } });
  };

  const clearSelection = () => {
    onChange({ target: { name, value: [] } });
    setSearchTerm(''); // ✅ ADDED: Clear search when selection is cleared
  };

  // ✅ ADDED: Filter the options based on the search term
  const filteredOptions = options.filter(opt =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  let displayText = "All";
  if (value.length === 1) displayText = value[0];
  else if (value.length > 1) displayText = `${value.length} Selected`;

  return (
    <div className="flex flex-col gap-1 relative" ref={dropdownRef}>
      <label className="text-[10px] uppercase font-bold text-slate-400">
        {label}
      </label>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="border border-slate-200 rounded-md p-2 text-sm outline-none bg-slate-50 h-[38px] flex items-center justify-between cursor-pointer"
      >
        <span className="truncate text-slate-700">{displayText}</span>
        <ChevronDown size={14} className="text-slate-400" />
      </div>
      
      {isOpen && (
        <div className="absolute z-50 top-[60px] left-0 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-72 flex flex-col overflow-hidden">
          
          {/* ✅ ADDED: Search Input Bar */}
          <div className="p-2 border-b border-slate-100 bg-white">
            <input
              type="text"
              placeholder={`Search ${label}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-slate-200 rounded p-1.5 text-sm outline-none focus:border-blue-500 text-slate-700 bg-slate-50"
              onClick={(e) => e.stopPropagation()} // Prevents dropdown from closing when clicking input
            />
          </div>

          {/* Scrollable Options List */}
          <div className="overflow-y-auto flex-1">
            <div 
              className="px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer border-b border-slate-100 text-red-500 font-medium"
              onClick={clearSelection}
            >
              Clear Selection
            </div>
            
            {/* ✅ ADDED: Renders filtered options or a "not found" message */}
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt, index) => (
                <label key={index} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={value.includes(opt)}
                    onChange={() => handleCheckboxChange(opt)}
                    className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                  />
                  <span className="truncate text-slate-700">{opt}</span>
                </label>
              ))
            ) : (
              <div className="px-3 py-4 text-sm text-center text-slate-400">
                No options found
              </div>
            )}
          </div>

        </div>
      )}
    </div>
  );
};

export default AccountDashboard;